module.exports = __webpack_public_path__ + "img/13.e58de392.jpg";